import { Component, Input } from '@angular/core';

@Component({
	selector: 'sb-landing-page-static',
	standalone: true,
	imports: [],
	template: `
		<div class="landing-content">
			<div class="center-body">
				<div class="linq-box landing-image-logo"></div>
				<div class="right-content heading-{{ module }}">
					<div class="landing-image-{{ module }}"></div>
				</div>
			</div>
		</div>
	`,
	styleUrl: './landing-page-static.component.less',
})
export class LandingPageStaticComponent {
	/**
	 * The module to display in the landing page. The value corresponds to the module name abbreviation used
	 * in the name of classes defined in the main stylesheet (styles.less). The allowed values should not be
	 * changed without updating the stylesheet accordingly.
	 */
	@Input() module: 'sa' | 'system' = 'sa';
}
